import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { DemoRoster } from '../api/demoRoster.js';
import { reseedDemoPatients } from '../api/reseedDemoPatients.js';
import { markDemoCopyResetting } from './demoResetInFlight.js';
import { sandboxDemoKeys } from './keys.js';
import { writeDemoRoster } from './rosterCache.js';

export function useReseedDemoPatientsMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['sandbox-demo', 'reseed'],
    mutationFn: (slugs: string[]) => reseedDemoPatients(slugs),
    onSuccess: (roster, slugs) => {
      const previous = queryClient.getQueryData<DemoRoster>(sandboxDemoKeys.roster);
      writeDemoRoster(queryClient, roster);
      for (const slug of slugs) {
        const prior = previous?.slots.find((slot) => slot.slug === slug);
        if (prior?.state.type === 'ready') {
          markDemoCopyResetting(prior.state.patient_user_id, slug);
        }
      }
    },
  });
}
